// Quick chips and the custom range both submit the live task filter form.
(function () {
    function applyDates(preset, from, to) {
        var form = document.getElementById('task-filter-form');
        form.elements.next_action.value = preset;
        form.elements.next_action_from.value = from;
        form.elements.next_action_to.value = to;
        window.htmx.trigger(form, 'submit');
        if (window._cc) window._cc.closeAllDropdowns();
    }

    document.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-task-date-preset]');
        if (!chip) return;
        e.preventDefault();
        applyDates(chip.dataset.taskDatePreset, '', '');
    });

    document.addEventListener('submit', function (e) {
        if (e.target.id !== 'task-date-custom-form') return;
        e.preventDefault();
        var from = e.target.elements.next_action_from;
        var to = e.target.elements.next_action_to;
        to.setCustomValidity(from.value && to.value && from.value > to.value
            ? 'Choose an end date on or after the start date.' : '');
        if (!e.target.reportValidity()) return;
        applyDates('', from.value, to.value);
    });

    document.addEventListener('input', function (e) {
        if (e.target.closest('#task-date-custom-form')) {
            document.getElementById('task-next-action-to').setCustomValidity('');
        }
    });

    // The server normalizes date params; mirror that state after each result swap.
    document.body.addEventListener('htmx:afterSwap', function () {
        var region = document.querySelector('[data-work-task-list-region]');
        var form = document.getElementById('task-filter-form');
        var bar = document.querySelector('[data-task-date-filters]');
        if (!region || !form || !bar) return;
        var state = region.dataset;
        form.elements.next_action.value = state.nextAction;
        form.elements.next_action_from.value = state.nextActionFrom;
        form.elements.next_action_to.value = state.nextActionTo;
        document.getElementById('task-next-action-from').value = state.nextActionFrom;
        document.getElementById('task-next-action-to').value = state.nextActionTo;
        bar.querySelectorAll('[data-task-date-preset]').forEach(function (chip) {
            chip.classList.toggle('chip-active', chip.dataset.taskDatePreset === state.nextAction);
        });
        bar.querySelector('[data-task-date-dropdown]').classList.toggle('chip-active', !!state.nextActionLabel);
        bar.querySelector('[data-task-date-label]').textContent = 'Next Action'
            + (state.nextActionLabel ? ': ' + state.nextActionLabel : '');
    });
})();
